import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { authInterceptor, GlobalErrorHandler, httpLoadingInterceptor, languageInterceptor } from '#core';
import { environment } from '#environments';
import { LanguageLoader } from '#locale';
import { DialogService } from 'primeng/dynamicdialog';
import { LoadingIndicatorService, provideAuth, MsalConfiguration } from '#services';
import { primetheme } from '../styles/primetheme';
import { routes } from './app.routes';
import { appInitializer } from './app.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAppInitializer(appInitializer),
    provideHttpClient(withInterceptors([authInterceptor, languageInterceptor, httpLoadingInterceptor])),
    provideTranslateService({
      loader: provideTranslateLoader(LanguageLoader),
      fallbackLang: 'en',
      lang: 'en',
    }),
    providePrimeNG({
      theme: {
        preset: primetheme,
        options: {
          darkModeSelector: false,
        },
      },
      ripple: true,
    }),
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    DialogService,
    LoadingIndicatorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideAuth(environment.msal as MsalConfiguration),
  ],
};
